import { useState } from "react";

type InputProps = {
  label: string;
  error?: string;
  inputType?: "input" | "select";
  inputClass?: string;
  showLockDown?: boolean;
} & (
  | ({
      inputType?: "input";
    } & JSX.IntrinsicElements["input"])
  | ({
      inputType: "select";
    } & JSX.IntrinsicElements["select"])
);

export const INPUT_CLASS =
  " p-4 rounded w-full bg-main border-2 border-primary disabled:border-accent min-h-[60px]";

export const Input = ({
  error,
  className,
  inputClass,
  showLockDown,
  ...props
}: InputProps) => {
  const id = props.id ?? props.name;
  const [isLockedDown, setIsLockedDown] = useState(showLockDown);
  return (
    <div
      className={"my-1 xl:my-3 flex flex-col flex-1 items-start " + className}
    >
      <label className="mb-1 " htmlFor={id}>
        {props.label}
      </label>
      <InputComponent
        {...props}
        disabled={props.disabled || isLockedDown}
        className={inputClass}
      />
      {showLockDown ? (
        <div>
          <input
            name={props.name ? props.name + "_lockdown" : undefined}
            id={props.id + "_lockdown"}
            type="checkbox"
            className=""
            checked={isLockedDown ?? false}
            onChange={(evt) => {
              const { checked } = evt.target;
              setIsLockedDown(checked);
            }}
          />
          <label
            htmlFor={props.id + "_lockdown"}
            className="m-2 cursor-pointer"
          >
            Input locked
          </label>
        </div>
      ) : null}
      <div className="text-textWarning">{error}</div>
    </div>
  );
};

const InputComponent = ({ id, className, ...props }: InputProps) => {
  switch (props.inputType) {
    case "select":
      return <select className={className || INPUT_CLASS} {...props} id={id} />;
    case "input":
    default:
      return <input className={className || INPUT_CLASS} {...props} id={id} />;
  }
};
